<template>
  <div>
    <span :id="`${index}_${get('value')}`" class="emoji">
      {{ get('emoji') }}
    </span>
    <b-tooltip :target="`${index}_${get('value')}`">
      <div class="tooltip-info">
        {{ labels.rating[get('key')] }}
      </div>
    </b-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const AVAILABLE_RATINGS = [
  {
    key: 'veryUnhappy',
    value: 'very-unhappy',
    emoji: '😠',
  },
  {
    key: 'unhappy',
    value: 'unhappy',
    emoji: '🙁',
  },
  {
    key: 'noComments',
    value: 'no-comments',
    emoji: '😐',
  },
  {
    key: 'good',
    value: 'good',
    emoji: '😃',
  },
  {
    key: 'loveIt',
    value: 'love-it',
    emoji: '😍',
  },
]

const props = {
  rating: {
    required: true,
    type: String,
  },
  index: {
    required: true,
    type: String,
  },
}

export default {
  props,
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels: function() {
      return this.resources.page.home.feedbacks.tickets
    },
  },
  methods: {
    get(attribute) {
      const rating = AVAILABLE_RATINGS.find(r => r.value === this.rating)
      if (rating) return rating[attribute]
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';
.emoji {
  font-size: 18pt;
}
</style>
